import React from "react";
import { IconButton } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import CustomTooltip from "src/components/custom-tooltip";

const TwitterButton = ({ user, isProfilePrivate }) => {
    const handleClick = () => {
        const tweetText = "Check out my Adadot Profile";
        const tweetUrl = `https://me.adadot.com/personal-profile/${user.orgId}:${user.user_id}`;
        const twitterShareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
            `${tweetText} ${tweetUrl}`
        )}`;

        const width = 500;
        const height = 500;
        const left = window.innerWidth / 2 - width / 2;
        const top = window.innerHeight / 2 - height / 2;

        window.open(
            twitterShareUrl,
            "twitter_share",
            `width=${width}, height=${height}, top=${top}, left=${left}`
        );
    };

    return (
        <CustomTooltip
            title={
                isProfilePrivate
                    ? "You profile is private. Enable via  your account settings"
                    : "Share link via X"
            }
        >
            <div>
                <IconButton
                    onClick={handleClick}
                    aria-label="delete"
                    size="small"
                    disabled={isProfilePrivate}
                >
                    <TwitterIcon fontSize="small" />
                </IconButton>
            </div>
        </CustomTooltip>
    );
};

export default TwitterButton;
